import localforage from "localforage";

export const ManageVideoPlayer = {
  mounted() {
    localforage.getItem("manage_video_player").then((value) => {
      this.pushEvent("set_video_player", { show: value });
    });

    this.handleEvent("show_video_player", this.toggleVideoPlayer.bind(this));
  },

  toggleVideoPlayer({ show }) {
    localforage.setItem("manage_video_player", show);
    this.pushEvent("set_video_player", { show });
  },
};
